import { HttpClient, RouteGenerator } from "silver";
import { GradeLevel } from "shared/Api/GradeLevel";
import { isMyonApiSuccess, MyonApiResponse } from "shared/Api/MyonApiResponse";

export class ArticleGradeLevelService {

	constructor(private httpClient: HttpClient, private router: RouteGenerator) { }

	public async setArticleGradeLevel(article: number[], gradeLevel: GradeLevel, buildingId: number|null = null): Promise<void> {
		const url = this.router.generate("api/news/article", "setGradeLevel", undefined, "json");
		const response: MyonApiResponse<[]> = await this.httpClient.post(url, { body: { article, gradeLevel, buildingId }});
		if (!isMyonApiSuccess(response)) {
			console.error(response);
			throw new Error("Could not persist article grade level");
		}
	}
}
